export const DefaultInput = (props) => (
  <input
    {...props}
    type="text"
    className="px-2 w-full py-4 px-6 dark:bg-[#171F33] dark:text-grey focus:border focus:border-[#7AA5D2] rounded-lg focus:outline-none"
  />
);
